import TabsPane from './TabsPane';
import S from './TabsPane.styles';

const TabsPaneTab = S.TabsWrapper;

export { TabsPane, TabsPaneTab };
